/**
 * The page header: one slim row — a small tinted icon, the bold title with its status pill, the subtitle and grey meta
 * chips beside it, outlined actions on the right and a kebab. Destructive acts go in `menu` (marked `danger`), never as a red
 * button in the bar. `about`: what the page is for, behind the "i" beside the title (owner rule, 16 Oct 2026: the screen
 * shows only what a person acts on) — never a visible explanatory subtitle.
 */
import React from 'react';
import { Button, Dropdown } from 'antd';
import { EllipsisVertical } from 'lucide-react';
import { KPI } from './tokens';
import InfoHint from './InfoHint';
import PageReturn from '@/components/PageChrome/PageReturn';
import MenuItems from '@/menu-items/index';

export default function PageHeader({ icon: Icon, tone = 'info', title, about, status, subtitle, meta = [], actions, menu, menuLabel = 'More actions', extra, testId }) {
  const chips = meta.filter(Boolean);
  const navigation = MenuItems();
  return (
    <header className="cu-card cu-header" data-testid={testId}>
      {Icon ? <span className={`cu-tile cu-tone--${tone}`} aria-hidden><Icon size={KPI.iconGlyph} /></span> : null}
      <div className="cu-header-main">
        <div className="cu-header-titleline">
          <h1 className="cu-title">{title}</h1>
          {about ? <InfoHint label="About this page" testId={testId ? `${testId}-about` : 'cu-page-about'}>{about}</InfoHint> : null}
          {status}
        </div>
        {(subtitle || chips.length > 0) && (
          <div className="cu-header-subline">
            {subtitle ? <span className="cu-header-subtitle">{subtitle}</span> : null}
            {chips.length > 0 && <span className="cu-meta-list">{chips.map((c, i) => <React.Fragment key={i}>{c}</React.Fragment>)}</span>}
          </div>
        )}
      </div>
      <div className="cu-header-actions">
        {actions}
        {menu?.length > 0 && (
          <Dropdown menu={{ items: menu }} trigger={['click']} placement="bottomRight">
            <Button aria-label={menuLabel} icon={<EllipsisVertical size={18} />} />
          </Dropdown>
        )}
        <PageReturn navigation={navigation} placement="inline" />
      </div>
      {extra ? <div className="cu-header-extra">{extra}</div> : null}
    </header>
  );
}
